import { useNavigate } from "react-router-dom";
import { ArrowLeft, Scale, FileText, ExternalLink } from "lucide-react";

const DOCUMENTS = [
  { id: "cgu", title: "Conditions générales d'utilisation", file: "/cndp-ready/14_CGU_HANA.pdf" },
  { id: "privacy", title: "Politique de confidentialité", file: "/cndp-ready/06_POLITIQUE_CONFIDENTIALITE.pdf" },
  { id: "notice-fr", title: "Notice d'information patient (FR)", file: "/cndp-ready/12_NOTICE_PATIENT_FR.pdf" },
  { id: "notice-ar", title: "Notice d'information patient (AR)", file: "/cndp-ready/13_NOTICE_PATIENT_AR.pdf" },
  { id: "consent-fr", title: "Formulaire de consentement patient (FR)", file: "/cndp-ready/10_CONSENTEMENT_PATIENT_FR.pdf" },
  { id: "consent-ar", title: "Formulaire de consentement patient (AR)", file: "/cndp-ready/11_CONSENTEMENT_PATIENT_AR.pdf" },
];

export default function LegalDocumentsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50" data-testid="legal-documents-page">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <button
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}
            data-testid="legal-back-btn"
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
            aria-label="Retour"
          >
            <ArrowLeft className="w-5 h-5 text-slate-600" />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-teal-50 flex items-center justify-center">
              <Scale className="w-4 h-4 text-teal-600" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-slate-800">Documents réglementaires</h1>
              <p className="text-xs text-slate-500">CGU, confidentialité, notices et consentements</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6 space-y-3">
        {DOCUMENTS.map((doc) => (
          <a
            key={doc.id}
            href={doc.file}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`legal-doc-${doc.id}`}
            className="flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-4 py-3 hover:border-teal-300 hover:bg-teal-50/40 transition-colors"
          >
            <FileText className="w-5 h-5 text-teal-600 flex-shrink-0" />
            <span className="flex-1 text-sm font-medium text-slate-800">{doc.title}</span>
            <ExternalLink className="w-4 h-4 text-slate-400" />
          </a>
        ))}
        <p className="text-xs text-slate-400 mt-6 text-center">
          Documents statiques (PDF). Le recueil et la traçabilité du consentement patient restent gérés dans l'application.
        </p>
      </main>
    </div>
  );
}
